import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// project imports
import { Translation } from 'models/i18n';
import sk from './assets/translations/sk';
import en from './assets/translations/en';

// ==============================|| I18NEXT ||============================== //
i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: {
      [Translation.SK]: { translation: sk },
      [Translation.EN]: { translation: en }
    },
    lng: Translation.SK,
    fallbackLng: Translation.EN,
    debug: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
